import React from 'react';
import Icon from '../../../components/AppIcon';

const PrinterStats = ({ printers = [] }) => {
  const totalPrinters = printers.length;
  const activePrinters = printers.filter(p => p.status === 'active').length;
  const maintenancePrinters = printers.filter(p => p.needsMaintenance).length;
  const totalHours = printers.reduce((total, p) => total + (p.totalHours || 0), 0);

  const stats = [
    {
      title: 'Total de Impressoras',
      value: totalPrinters,
      icon: 'Printer',
      color: 'primary',
      description: 'Impressoras cadastradas'
    },
    {
      title: 'Ativas',
      value: activePrinters,
      icon: 'Play',
      color: 'success',
      description: 'Em funcionamento'
    },
    {
      title: 'Precisam Manutenção',
      value: maintenancePrinters,
      icon: 'AlertTriangle',
      color: 'warning',
      description: 'Requerem atenção'
    },
    {
      title: 'Horas Totais',
      value: `${totalHours}h`,
      icon: 'Clock',
      color: 'accent',
      description: 'Tempo de operação'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-2xl p-6">
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 bg-${stat.color}/10 rounded-lg flex items-center justify-center`}>
              <Icon name={stat.icon} size={20} className={`text-${stat.color}`} />
            </div>
            <div>
              <div className="text-2xl font-bold text-foreground">{stat.value}</div>
              <div className="text-sm text-muted-foreground">{stat.description}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PrinterStats;